//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

/**
 * Gets a doctor by id.
 * @param id The doctor id.
 */
export function getDoctor(id: number, config?: AxiosRequestConfig | undefined): Promise<Types.DoctorDto> {
    let url_ = getBaseUrl() + "/api/doctors/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDoctor,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDoctor?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDoctor(_response);
    });
}

function processGetDoctor(response: AxiosResponse): Promise<Types.DoctorDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDoctorDto(resultData200);
        return Promise.resolve<Types.DoctorDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DoctorDto>(null as any);
}

/**
 * Edits a doctor.
 * @param id The doctor id.
 * @param updatedDoctor Request parameter
 */
export function editDoctor(id: number, updatedDoctor: Types.UpdateDoctorDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/doctors/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeUpdateDoctorDto(updatedDoctor);

    let options_: AxiosRequestConfig = {
        ..._requestConfigEditDoctor,
        ...config,
        data: content_,
        method: "PATCH",
        url: url_,
        headers: {
            ..._requestConfigEditDoctor?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processEditDoctor(_response);
    });
}

function processEditDoctor(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Removes a doctor.
 * @param id The doctor id.
 */
export function removeDoctor(id: number, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/doctors/{id}";
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace("{id}", encodeURIComponent("" + id));
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigRemoveDoctor,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigRemoveDoctor?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processRemoveDoctor(_response);
    });
}

function processRemoveDoctor(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

/**
 * Gets doctors.
 * @param all (optional) Get all doctors without filtering
 * @param doctorType (optional) 
 * @param doctorIds (optional) 
 * @param doctorCisIds (optional) 
 * @param searchQuery (optional) 
 * @param isOnlyActive (optional) 
 * @param doctorImportIds (optional) 
 * @param includeDeleted (optional) 
 * @param isUsedAsResource (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function getDoctors(all?: boolean | undefined, doctorType?: Types.DoctorType | null | undefined, doctorIds?: number[] | null | undefined, doctorCisIds?: string[] | null | undefined, searchQuery?: string | null | undefined, isOnlyActive?: boolean | null | undefined, doctorImportIds?: string[] | null | undefined, includeDeleted?: boolean | null | undefined, isUsedAsResource?: boolean | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, config?: AxiosRequestConfig | undefined): Promise<Types.PageableListDtoOfDoctorListDto> {
    let url_ = getBaseUrl() + "/api/doctors?";
    if (all === null)
        throw new Error("The parameter 'all' cannot be null.");
    else if (all !== undefined)
        url_ += "all=" + encodeURIComponent("" + all) + "&";
    if (doctorType !== undefined && doctorType !== null)
        url_ += "DoctorType=" + encodeURIComponent("" + doctorType) + "&";
    if (doctorIds !== undefined && doctorIds !== null)
        doctorIds && doctorIds.forEach(item => { url_ += "DoctorIds=" + encodeURIComponent("" + item) + "&"; });
    if (doctorCisIds !== undefined && doctorCisIds !== null)
        doctorCisIds && doctorCisIds.forEach(item => { url_ += "DoctorCisIds=" + encodeURIComponent("" + item) + "&"; });
    if (searchQuery !== undefined && searchQuery !== null)
        url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
    if (isOnlyActive !== undefined && isOnlyActive !== null)
        url_ += "IsOnlyActive=" + encodeURIComponent("" + isOnlyActive) + "&";
    if (doctorImportIds !== undefined && doctorImportIds !== null)
        doctorImportIds && doctorImportIds.forEach(item => { url_ += "DoctorImportIds=" + encodeURIComponent("" + item) + "&"; });
    if (includeDeleted !== undefined && includeDeleted !== null)
        url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
    if (isUsedAsResource !== undefined && isUsedAsResource !== null)
        url_ += "IsUsedAsResource=" + encodeURIComponent("" + isUsedAsResource) + "&";
    if (pagination_Offset === null)
        throw new Error("The parameter 'pagination_Offset' cannot be null.");
    else if (pagination_Offset !== undefined)
        url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
    if (pagination_Limit === null)
        throw new Error("The parameter 'pagination_Limit' cannot be null.");
    else if (pagination_Limit !== undefined)
        url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
    if (sorting_SortField !== undefined && sorting_SortField !== null)
        url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
    if (sorting_SortDirection === null)
        throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
    else if (sorting_SortDirection !== undefined)
        url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
    if (additionalSorting !== undefined && additionalSorting !== null)
        additionalSorting && additionalSorting.forEach((item, index) => {
            for (let attr in item)
    			if (item.hasOwnProperty(attr)) {
    				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
    			}
        });
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigGetDoctors,
        ...config,
        method: "GET",
        url: url_,
        headers: {
            ..._requestConfigGetDoctors?.headers,
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processGetDoctors(_response);
    });
}

function processGetDoctors(response: AxiosResponse): Promise<Types.PageableListDtoOfDoctorListDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initPageableListDtoOfDoctorListDto(resultData200);
        return Promise.resolve<Types.PageableListDtoOfDoctorListDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.PageableListDtoOfDoctorListDto>(null as any);
}

/**
 * Creates a doctor.
 * @param newDoctor Request parameter
 */
export function createDoctor(newDoctor: Types.CreateDoctorDto, config?: AxiosRequestConfig | undefined): Promise<Types.DoctorDto> {
    let url_ = getBaseUrl() + "/api/doctors";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeCreateDoctorDto(newDoctor);

    let options_: AxiosRequestConfig = {
        ..._requestConfigCreateDoctor,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigCreateDoctor?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processCreateDoctor(_response);
    });
}

function processCreateDoctor(response: AxiosResponse): Promise<Types.DoctorDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("Invalid data was specified.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDoctorDto(resultData200);
        return Promise.resolve<Types.DoctorDto>(result200);

    } else if (status === 201) {
        const _responseText = response.data;
        let result201: any = null;
        let resultData201  = _responseText;
        result201 = Types.initDoctorDto(resultData201);
        return Promise.resolve<Types.DoctorDto>(result201);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DoctorDto>(null as any);
}
let _requestConfigGetDoctor: Partial<AxiosRequestConfig> | null;
export function getGetDoctorRequestConfig() {
  return _requestConfigGetDoctor;
}
export function setGetDoctorRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDoctor = value;
}
export function patchGetDoctorRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDoctor = patch(_requestConfigGetDoctor ?? {});
}

let _requestConfigEditDoctor: Partial<AxiosRequestConfig> | null;
export function getEditDoctorRequestConfig() {
  return _requestConfigEditDoctor;
}
export function setEditDoctorRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigEditDoctor = value;
}
export function patchEditDoctorRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigEditDoctor = patch(_requestConfigEditDoctor ?? {});
}

let _requestConfigRemoveDoctor: Partial<AxiosRequestConfig> | null;
export function getRemoveDoctorRequestConfig() {
  return _requestConfigRemoveDoctor;
}
export function setRemoveDoctorRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigRemoveDoctor = value;
}
export function patchRemoveDoctorRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigRemoveDoctor = patch(_requestConfigRemoveDoctor ?? {});
}

let _requestConfigGetDoctors: Partial<AxiosRequestConfig> | null;
export function getGetDoctorsRequestConfig() {
  return _requestConfigGetDoctors;
}
export function setGetDoctorsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigGetDoctors = value;
}
export function patchGetDoctorsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigGetDoctors = patch(_requestConfigGetDoctors ?? {});
}

let _requestConfigCreateDoctor: Partial<AxiosRequestConfig> | null;
export function getCreateDoctorRequestConfig() {
  return _requestConfigCreateDoctor;
}
export function setCreateDoctorRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigCreateDoctor = value;
}
export function patchCreateDoctorRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigCreateDoctor = patch(_requestConfigCreateDoctor ?? {});
}